module.exports = __webpack_public_path__ + "static/media/inc-500.c9fb4ac3.png";